module.exports = __webpack_public_path__ + "static/66-north-1-f3364bd6b96fff3001613e036c86eb43.jpg";